exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-246d0dc2]{text-align:left;padding-bottom:8px}", ""]);

// exports
